<div class="dynamic-field-container">
  <div class="dynamic-field form-input text-align dynamic-button-group pb-2">
    <hr />
    <div #coachingResult class="button-group-container">
      <button
        class="k-button"
        [class.k-primary]="selectedButton === 'aiapproved'"
        (click)="selectedButton = 'aiapproved'"
        [disabled]="true"
      >
        Approve
      </button>
      <button
        class="k-button"
        [class.k-primary]="selectedButton === 'aicoached'"
        (click)="selectedButton = 'aicoached'"
        [disabled]="true"
      >
        Coach
      </button>
    </div>

    <label>AI Coaching Result</label>
    <p>{{ feedback }}</p>
    <div class="d-flex flex-column gap-3 mb-3">
      <div class="d-flex gap-3">
        <div class="flex-grow-1">
          <div class="mt-2">
            <label>Likelihood : {{ likelihood }}</label>
          </div>
          <div class="mt-1">
            <p>{{ likelihoodReason }}</p>
          </div>
        </div>
      </div>

      <div class="d-flex gap-3">
        <div class="flex-grow-1">
          <div class="mt-2">
            <label>Impact : {{ impact }}</label>
          </div>
          <div class="mt-1">
            <p>{{ impactReason }}</p>
          </div>
        </div>
      </div>

      <div class="d-flex gap-3">
        <div class="flex-grow-1">
          <div class="mt-2">
            <label>Value : {{ value }}</label>
          </div>
          <div class="mt-1">
            <p>{{ valueReason }}</p>
          </div>
        </div>
      </div>
    </div>

    @if (formReview === null) {
    <button
      class="k-button k-primary"
      (click)="submitAiCoaching()"
      [disabled]="
        reviewDate !== null || feedback !== null || isAiCoachingSubmitted
      "
    >
      AI Coaching
    </button>
    } @if (reviewDate) {
    <h5>AI Coached At: {{ reviewDate | date: 'short' }}</h5>
    }
  </div>
</div>
<!-- Recommended Form Reclassification -->
@if (recommendReclassify) {
<div class="dynamic-field-container">
  <div class="dynamic-field form-input text-align">
    <hr />
    <label>Recommended Form to Reclassify</label>
    <input
      type="text"
      class="k-textbox w-100"
      [(ngModel)]="recommendedForm"
      [disabled]="formReview !== null"
    />

    <label class="mt-3">Reclassify Reason</label>
    <textarea
      class="k-textbox"
      [attr.name]="reclassifyReason"
      [attr.maxLength]="500"
      [(ngModel)]="reclassifyReason"
      [disabled]="formReview !== null"
    ></textarea>
  </div>
</div>
}
